var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavePrendo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 841.89",
    fill: "none",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.23,526.68c334.53-8.21,384.57-112.79,816.53-99.42 c82.37,2.55,152.58,15.92,212.24,35.86V0L0,0v488.32C59.93,509.74,163.88,530.93,337.23,526.68z",
    fill: "url(#gradient_01_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337.23,526.68c334.53-8.21,384.57-112.79,816.53-99.42 c82.37,2.55,152.58,15.92,212.24,35.86V0L0,0v488.32C59.93,509.74,163.88,530.93,337.23,526.68z",
    fill: "url(#gradient_01_4_)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_01_4_",
    x1: 0,
    y1: 0,
    x2: "85%",
    y2: 693.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6910FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624484,
    stopColor: "#882CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979283,
    stopColor: "#9A3CF7",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C3DF7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_01_1_",
    x1: -0.00000169897,
    y1: 115.5,
    x2: 383,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00890856,
    stopColor: "#3379F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePrendo);
export default __webpack_public_path__ + "static/media/wave-prendo.bd25769504428aa87f7369ae406b088d.svg";
export { ForwardRef as ReactComponent };